import React from 'react'

import { Modal, Button, Table, Form } from '_zari/core'

const TablaDetallesModal = ({ handleClose, show, modalData }) => {
  return (
    <Modal size='md' show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title>Detalle Kardex</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className='mb-2' style={{ fontSize: '13px' }}>
          <div><strong>MONEDA:</strong> {modalData.moneda}</div>
          {modalData.ruc && modalData.ruc !== '---' ? (
            <div><strong>RUC:</strong> {modalData.ruc}</div>
          ) : null}
          {modalData.razSoc && modalData.razSoc !== '---' ? (
            <div><strong>RAZÓN SOCIAL:</strong> {modalData.razSoc}</div>
          ) : null}
        </div>
        <Table
          className='text-center'
          filas={modalData.arrayDetalles}
          maxRowsShown={10}
          headRows={[
            {
              label: 'FECHA'
            },
            {
              label: 'CODIGO'
            },
            {
              label: 'PRODUCTO'
            },
            {
              label: 'CANTIDAD'
            },
            {
              label: 'PRECIO'
            }
          ]}
          rowTemplate={(row, key) => (
            <Table.Row key={key}>
              <Table.Cell className='text-center'>{row.fecha}</Table.Cell>
              <Table.Cell className='text-center'>{row.codigo}</Table.Cell>
              <Table.Cell className='text-center'>{row.nombre}</Table.Cell>
              <Table.Cell className='text-center'>{row.cantidad}</Table.Cell>
              <Table.Cell className='text-center'>{row.precio}</Table.Cell>
            </Table.Row>
          )}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TablaDetallesModal)
